import React from "react";
import { Box } from "@mui/material";

import { splitParagraphWithHighLights } from "utils/highlighting";

/**
 * The candidate's transcript with flagged words highlighted in red.
 *
 * Reuses desktop's `splitParagraphWithHighLights` util. We gather every flagged
 * span across the communication + content tags (fillers, informal words, etc.),
 * drop overlaps, and mark those spans red — a single combined highlight rather
 * than desktop's category-tabbed view, matching the mobile design.
 *
 * @param {object} question
 */
export default function ResponseHighlight({ question }) {
  const segments = React.useMemo(() => {
    if (!question?.transcript) return [];

    const tags = [
      ...(question?.communication?.tags || []),
      ...(question?.content?.tags || []),
    ];

    const positions = [];
    tags.forEach((tag) => {
      (Array.isArray(tag.value) ? tag.value : []).forEach((data) => {
        (data?.positions || []).forEach((p) => {
          if (p && typeof p.start === "number" && typeof p.end === "number") {
            positions.push({ positions: [p.start, p.end] });
          }
        });
      });
    });

    positions.sort((a, b) => a.positions[0] - b.positions[0]);

    // Keep only non-overlapping spans (desktop's util assumes ordered, disjoint).
    const merged = [];
    let lastEnd = -1;
    positions.forEach((p) => {
      if (p.positions[0] > lastEnd) {
        merged.push(p);
        lastEnd = p.positions[1];
      }
    });

    return splitParagraphWithHighLights(merged, question);
  }, [question]);

  if (!segments.length) {
    return <>{question?.transcript || "---"}</>;
  }

  return (
    <>
      {segments.map((seg, i) =>
        seg.positions ? (
          <Box key={i} component="span" sx={{ color: "danger.clr-700", fontWeight: 600 }}>
            {seg.transcript}
          </Box>
        ) : (
          <React.Fragment key={i}>{seg.transcript}</React.Fragment>
        )
      )}
    </>
  );
}
